











































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import RenderlessPagination from './RenderlessPagination.vue';

@Component({
    components: {
        RenderlessPagination,
    },
    props: {
        data: {
            type: Object,
            required: true,
            default: () => ({
                meta: {},
                data: [],
                links: {},
            }),
        },
        limit: {
            type: Number,
            default: 1,
        },
        showDisabled: {
            type: Boolean,
            default: true,
        },
        showNumbers: {
            type: Boolean,
            default: false,
        },
        hideWhenEmpty: {
            type: Boolean,
            default: true,
        },
        translate: {
            type: Object,
            default: () => ({
                nextButton: 'Next',
                previousButton: 'Previous',
            }),
        },
    },

})

export default class Pagination extends Vue {

    @Prop({ type: String, default: 'default' }) private size: string;
    @Prop({
        type: String,
        default: 'tailwind',
        validator: (value) => {
            return [
                'bootstrap',
                'tailwind',
            ].indexOf(value) !== -1;
        },
    }) private framework: string;

    private onPaginationChangePage(page: number) {
        this.$emit('page-changed', page);
    }

    private numberButtonClasses(page, currentPage): object {
        return {
            'inline-flex items-center h-full mx-1 text-base font-medium leading-5 transition duration-150 ease-in-out rounded-md active:bg-gray-200 focus:outline-none focus:border-blue-300 focus:shadow-outline active:text-gray-700': this.framework === 'tailwind',
            'px-2 py-1': this.size === 'small' && this.framework === 'tailwind',
            'px-4 py-2': this.size === 'default' && this.framework === 'tailwind',
            'bg-blue-500 text-white': page === currentPage && this.framework === 'tailwind',
            'text-gray-700 border border-gray-400 hover:bg-gray-200': page !== currentPage && this.framework === 'tailwind',
            'page-link': this.framework === 'bootstrap',
        };
    }

    get containerClasses(): object {
        return {
            'flex flex-col items-center justify-between px-4 py-2 sm:flex-row': this.framework === 'tailwind',
        };
    }

    get ulClasses(): object {
        return {
            'relative inline-flex list-none': this.framework === 'tailwind',
            'pagination': this.framework === 'bootstrap',
            'pagination-sm': this.size === 'small' && this.framework === 'bootstrap',
            'pagination-lg': this.size === 'large' && this.framework === 'bootstrap',
        };
    }

    get previousButtonClasses(): object {
        return {
            'inline-flex items-center h-full mx-1 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out border border-gray-400 rounded-md hover:bg-gray-200 active:bg-gray-200 focus:outline-none focus:border-blue-300 focus:shadow-outline active:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed': this.framework === 'tailwind',
            'px-2 py-2': this.size === 'default' && this.framework === 'tailwind',
            'px-1 py-1': this.size === 'small' && this.framework === 'tailwind',
            'page-link': this.framework === 'bootstrap',
        };
    }

    get previousButtonIconClasses(): object {

        return {
            'w-5 h-5': this.size === 'default' && this.framework === 'tailwind',
            'w-4 h-4': this.size === 'small' && this.framework === 'tailwind',
        };
    }

    get nextButtonClasses(): object {
        return {
            'inline-flex items-center h-full mx-1 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-400 rounded-md hover:bg-gray-200 active:bg-gray-200 focus:outline-none focus:border-blue-300 focus:shadow-outline active:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed': this.framework === 'tailwind',
            'px-2 py-2': this.size === 'default' && this.framework === 'tailwind',
            'px-1 py-1': this.size === 'small' && this.framework === 'tailwind',
            'page-link': this.framework === 'bootstrap',
        };
    }

    get nextButtonIconClasses(): object {
        return {
            'w-5 h-5': this.size === 'default' && this.framework === 'tailwind',
            'w-4 h-4': this.size === 'small' && this.framework === 'tailwind',
        };
    }
}
